import { ThemeTokens } from '../tokens';

export const natureTheme: ThemeTokens = {
  canvas: {
    gradient: 'linear-gradient(135deg, #0E2525 0%, #163737 50%, #0E2525 100%)',
    panel: '#102E2E',
    menu: '#1e293b',
  },
  card: {
    background: '#0a1f1f',
    backgroundGradient: 'linear-gradient(135deg, rgba(255,255,255,0.08) 0%, rgba(255,255,255,0.05) 100%)',
    border: '0.5px solid rgba(255, 255, 255, 0.1)',
    hoverBorder: '1px solid rgba(255, 255, 255, 0.3)',
    hoverShadow: '0 4px 12px rgba(0, 0, 0, 0.4)',
  },
  border: {
    light: '1px solid rgba(255, 255, 255, 0.1)',
  },
  text: {
    primary: '#ffffff',
    secondary: 'rgba(255, 255, 255, 0.6)',
    disabled: 'rgba(255, 255, 255, 0.5)',
  },
  interactive: {
    hover: 'rgba(255, 255, 255, 0.08)',
    active: '#2a3f3f',
    toggleBg: 'rgba(255, 255, 255, 0.1)',
    toggleBorder: 'rgba(255, 255, 255, 0.1)',
    toggleInactive: 'rgba(255, 255, 255, 0.5)',
    toggleActive: 'rgba(255, 255, 255, 0.2)',
    toggleActiveText: 'rgba(255, 255, 255, 0.9)',
  },
  accent: {
    avatar: {
      gradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    },
    success: {
      bg: 'rgba(76, 175, 80, 0.2)',
      bgHover: '#4CAF50',
    },
    icon: '#00D9D9',
  },
  dropdown: {
    background: '#1e293b',
    sectionText: 'rgba(255, 255, 255, 0.6)',
    optionText: 'rgba(255, 255, 255, 0.9)',
    optionHoverBg: 'rgba(255, 255, 255, 0.08)',
    divider: 'rgba(255, 255, 255, 0.15)',
    checkboxUnchecked: 'rgba(255, 255, 255, 0.5)',
  },
};
